import { action, observable } from "mobx";

import CONTENT_VIEW_TYPES from "../../constants/contentViewTypes";

const withValuationContent = BaseClass =>
  class extends BaseClass {
    @observable contentView = CONTENT_VIEW_TYPES.cta;

    @action.bound
    setContentView(viewType) {
      this.contentView = viewType;
    }
  };

export default withValuationContent;
